import React from "react";
import "./AboutWhy.css";
import yellowone from "../../assets/yellowone.png";
import yellowtwo from "../../assets/yellowtwo.png";
import peoplehero from "../../assets/peoplehero.png";
import bgpeoplehero from "../../assets/bgpeoplehero.png";

const AboutWhy = () => {
  return (
    <div className="aboutwhy-body">
      <div className="aboutwhy-container">
        <div className="first" data-aos="fade-right">
          <div className="header">
            <h2>Why Freelancemedic?</h2>

            <div className="first-para">
              <p>
                Across Africa, the demand for reliable, skilled healthcare
                professionals is rising; not just in hospitals and clinics, but
                also in homes, events, corporate settings, emergency responses,
                and specialized care services. FreelanceMedic was created to
                make it easier for organizations and to access verified,
                licensed professionals exactly when they are needed without
                delays or staffing disruptions.
              </p>

              <p>
                Our platform simplifies how you request, manage, and retain
                healthcare professionals. From shift scheduling to payment
                tracking and compliance checks, everything happens in one smart,
                secure dashboard. Whether you are managing a busy facility,
                organizing a medical outreach, or need urgent coverage for a
                private service, FreelanceMedic connects you to trusted
                professionals ready to deliver.
              </p>

              <p>
                With our embedded features, you can build a consistent team of
                healthcare professionals who understand your standards and
                deliver with reliability. FreelanceMedic is not just about
                filling gaps it is about enabling uninterrupted, high-quality
                care across all environments where health expertise is
                essential.
              </p>
            </div>

            <img className="yellowone" src={yellowone} alt="yellowone" />
            <img className="yellowtwo" src={yellowtwo} alt="yellowtwo" />
          </div>
        </div>

        <div className="second" data-aos="fade-left">
          <img className="peoplehero" src={peoplehero} alt="peoplehero" />
          <img className="bgpeoplehero" src={bgpeoplehero} alt="bgpeoplehero" />
        </div>
      </div>
    </div>
  );
};

export default AboutWhy;
